import { render, staticRenderFns } from "./categoriesDropdownlist.vue?vue&type=template&id=42686049"
import script from "./categoriesDropdownlist.js?vue&type=script&lang=js&external"
export * from "./categoriesDropdownlist.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports